import { createAction, handleActions } from 'redux-actions';
import { useRedux } from 'util/hook/redux';
import { updateRecordId } from 'models/receiptForm';
import { Dispatch } from 'redux';

/* 若需客製化 api 時可以引入如： { api, customGRApi } 其中 customGRApi 在 'util/api'做設定 */
import { api } from 'util/api';

/**
 * 這邊需注意 swagger schema 回來的 data-contracts 內的 v1WebEventsList return 型別
 * 為 EventShowResource [], 實際上 api 卻是 EventShowResource
 * 不確定是否為 swagger schema 沒有跟著調整所導致, 若有再次進行 API library 的 yarn api:create
 * 可能就需要重新檢查這個型別, 因目前 store 設定（event 內頁 getEvent, init state）
 * 都以 EventShowResource 為主 若沒檢查可能接起來在頁面上使用會出錯
 */
import {
	EventRegistrationIndexResource,
	EventRegistrationShowResource,
} from 'util/api/swaggerApi/data-contracts';
import { State as GlobalState } from './reducers';

export const getRecords = createAction('GET_RECORDS', async () => {
	try {
		const { v1WebEventRegistrationsList } = api;
		const data = await v1WebEventRegistrationsList({ secure: true });

		const resultArray = data?.data || [];

		return resultArray;
	} catch (error) {
		console.log('error!', error);

		return [];
	}
});

export const getRecord = createAction(
	'GET_RECORD',
	(recordId: number) => async (dispatch: Dispatch) => {
		try {
			const { v1WebEventRegistrationsDetail } = api;
			const data = await v1WebEventRegistrationsDetail(recordId, { secure: true });

			const resultArray = data?.data || undefined;
			await dispatch(
				updateRecordId({
					key: 'recordId',
					value: String(recordId),
					data: { value: String(recordId), error: '' }, // assuming error is empty in this case
				}),
			);

			localStorage.setItem('recordId', String(recordId));

			return resultArray;
		} catch (error) {
			console.log('error!', error);

			return {};
		}
	},
);

export interface State {
	loading: boolean;
	records: EventRegistrationIndexResource[];
	record: EventRegistrationShowResource | undefined;
}

export const defaultState: State = {
	loading: false,
	records: [],
	record: undefined,
};

export const reducer = {
	records: handleActions<State, any>( // eslint-disable-line @typescript-eslint/no-explicit-any
		{
			GET_RECORDS_PENDING: state => ({
				...state,
				loading: true,
			}),

			GET_RECORDS_FULFILLED: (state, action) => ({
				...state,
				records: action.payload,
				loading: false,
			}),

			GET_RECORD_PENDING: state => ({
				...state,
				loading: true,
			}),

			GET_RECORD_FULFILLED: (state, action) => ({
				...state,
				record: action.payload,
				loading: false,
			}),
		},
		defaultState,
	),
};

const recordsActionsMap = {
	getRecords,
	getRecord,
};

const mapHooksToState = (state: GlobalState) => ({
	records: state.records.records,
	record: state.records.record,
});

type RecordsSelector = ReturnType<typeof mapHooksToState>;
type RecordsActionsMap = typeof recordsActionsMap;

export const useRecords = () =>
	useRedux<RecordsSelector, RecordsActionsMap>(mapHooksToState, recordsActionsMap);
